<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>新建员工费用</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display: flex;justify-content: space-between">
      <div style="width: 20%">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            @node-click="handleNodeClick"
            :highlight-current="true"
            node-key="id"
            show-checkbox
            @check="handleCheckChange"
            :filter-node-method="filterNode"
            ref="tree"
          >
          </el-tree>
        </div>
      </div>
      <div class="table_container" style="border: 0 solid rgb(222,222,222);">
        <el-button size="mini"  @click="addSubsidyListMethod">添加一行</el-button>
        <el-table :data="subsidyList" fit border stripe="stripe"
                  height="500px" :cell-style="{padding: '5px'}"
                  :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            prop="userName"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteCost(scope.$index, subsidyList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="月份" width="200px">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.costDate"
                type="month"
                size="mini"
                style="width: 150px;"
                value-format="yyyy-MM"
              >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="类目" width="160px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.costId" clearable value filterable
                         style="width: 120px" size="mini" >
                <el-option
                  v-for="orgCost in orgCostList"
                  :key="orgCost.costId"
                  :label="orgCost.costCnName"
                  :value="orgCost.costId">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="money"
            label="金额/天数">
            <template slot-scope="scope">
              <el-input v-model="scope.row.money" onkeyup="value=value.replace(/[^\d.]/g,'')" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="备注">
            <template slot-scope="scope">
              <el-input v-model="scope.row.comment" size="mini"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <span class="dialog-footer">
          <el-button size="mini" @click="closeUserSubsidyDialog">返 回</el-button>
          <el-button size="mini" @click="createUserSubsidy">确 定</el-button>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      userName:'',
      orgId: '',
      userId:'',
      authorities:'',
      filterText:'',
      orgList:[],
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      selectEmployeeList:[],
      selectedUser:'',
      userList:[],
      subsidyList:[],
      orgCostList:[],
      total:0,
      searchText:'',
      selectedAreaId:0,
      userCost:{
        orgIds:[],
        creator:'',
        createName:'',
        subsidyList:[],
      },
    }
  },
  methods:{
    async handleCheckChange() {
      this.userCost.orgIds = this.$refs.tree.getCheckedKeys();
    },
    async selectUser(row){
      this.selectedUser = row;
    },
    handleSelectionChange(val){
      this.selectEmployeeList = val;
    },
    async handleNodeClick() {
      this.subsidyList = [];
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    async loadOrg(){
      const {data:res} = await this.$http.get(`orgList/orgId/${this.orgId}`);
      this.orgList = [res.data];
    },
    addSubsidyListMethod(){
      let currentDate = this.getCurrentDate();
      let userCost = {
        costDate: currentDate,
        money:'',
        costId:'',
        comment:'',
      }
      if(this.subsidyList.length < this.total){
        this.subsidyList.push(userCost);
      }
    },
    async loadOrgCost(){
      const {data:res} = await this.$http.get(`/cost/orgId/${this.orgId}/costType/${3}`);
      this.orgCostList = res.data;
      this.total = this.orgCostList.length;
    },
    //获取系统当前日期
    getCurrentDate() {
      let date = new Date(new Date().getTime());
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month
      return year + '-' + month;
    },
    async createUserSubsidy(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      if(this.userCost.orgIds.length == 0){
        this.$message.warning("请选择机构!")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return;
      }
      this.userCost.subsidyList = this.subsidyList;
      this.userCost.creator = this.userId;
      this.userCost.createName = this.userName;
      const {data:res} = await this.$http.post(`/cost/addShopCost`, this.userCost);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closeUserSubsidyDialog();
    },
    closeUserSubsidyDialog(){
      this.$router.go(-1);
    },
    deleteCost(index,rows){
      rows.splice(index, 1);
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.userName = window.sessionStorage.getItem("userName");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
    this.loadOrgCost();
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_con{
  height: 100%;
  overflow-y: auto;
  flex: 1;
  margin: 10px 0;
  /*border: 1px solid;*/
}
.table_container{
  width: 80%;
  flex: 4;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.outside_con{
  height: 250px;
}
.dialog-footer{
  display: flex;
  margin-top: 50px;
  //margin: 10px 10px;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/NewShopCost.vue